const bands = [
  [0, 15624, 0.075],
  [15624, 30855.48, 0.09],
  [30855.48, 46283.28, 0.12],
  [46283.28, 90096.65, 0.14],
];

const INSS_DEDUCTION_LIMIT = 10526.90;

export const getINSSDeduction = (taxableGrossIncome) => {
  const bandsValues = bands.map(([min, max, rate]) => {
    if (taxableGrossIncome < min) {
      return 0;
    }
    if (taxableGrossIncome >= max) {
      return (max - min) * rate;
    } else {
      return (taxableGrossIncome - min) * rate;
    }
  });
  const total = bandsValues.reduce((p, c) => {
    return p + c;
  }, 0);
  return Math.min(total, INSS_DEDUCTION_LIMIT);
};
